enum AccountStatus {
  ACTIVE = 'Active',
  PENDING_LINKED_SAVER = 'Waiting for Link',
  MISSING_LINKED_SAVER = 'Missing Link',
  MISSING_PRIMARY_RELATIONSHIP = 'Non-Primary',
  MISSING_ACCOUNT_RELATIONSHIP = 'Relationship Missing',
  ACCOUNT_DISAPPEARED = 'Missing Data',
}

export default AccountStatus;
